import styled from 'styled-components'
import { IoCloseOutline } from "react-icons/io5";
import { Link as LinkR } from 'react-router-dom'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 99999;
    width: 100%;
    height: 100%;
    background: #fff;
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`
export const CloseIcon = styled(IoCloseOutline)`
    color: #000;
`
export const Icon = styled.div`
    padding-top: 11px;
    padding-right: 15px;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-210%, 100%);
    font-size: 2.5rem;
    cursor: pointer;
    color: #fff;

    @media screen and (max-width: 1170px) {
        transform: translate(-60%, 90%);
    }
`
export const SidebarWrapper = styled.div`
    color: #fff;
`
export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, 70px);
    text-align: center;
    margin-top: 180px;
    @media screen and (max-width: 480px){
    grid-template-rows: repeat(7, 60px);
`
export const SidebarLinkR = styled(LinkR)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    color: #000;
    cursor: pointer;
`